import { createSlice } from '@reduxjs/toolkit';

const menuSlice = createSlice({
    name: 'menu',
    initialState: {
      menuItems: {}
    },
    reducers: {
      setMenuInfo: (state, action) => {
        const { menuItems } = action.payload;
        state.menuItems = menuItems;   
      },
    },
  },
);

export const { setMenuInfo } = menuSlice.actions;
export default menuSlice.reducer;